import { DismissRegular } from '@fluentui/react-icons';
export interface ActiveFilter { key:string; label:string; remove():void }
export function ActiveFilters({items,clear}:{items:ActiveFilter[];clear():void}) {
  if(!items.length)return null;
  return <div className="active-filter-chips" aria-label="当前筛选条件"><span>正在筛选</span>{items.map(item=><button key={item.key} type="button" aria-label={`移除筛选：${item.label}`} onClick={item.remove}><span>{item.label}</span><DismissRegular/></button>)}<button type="button" onClick={clear}>清除全部</button></div>;
}
export function facetChips(label:string,ids:string[],options:{value:string;label:string}[],set:(ids:string[])=>void):ActiveFilter[]{
  return ids.map(id=>({key:`${label}:${id}`,label:`${label}：${options.find(x=>x.value===id)?.label??id}`,remove:()=>set(ids.filter(x=>x!==id))}));
}
